import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { ValidaEdicionResponse } from 'src/app/global/interfaces/valida-edicion-paso-tres-response';
import { ValidacionEdicionService } from 'src/app/global/services/validacion-edicion.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ValidacionEdicionProvider extends ValidacionEdicionService {

    private baseUrl = _.get(environment, 'api.host', '');
    private basePath = _.get(environment, 'api.path', '');
    private baseEndpoint = _.get(environment, 'api.endpoints', '');
    private endpoint: string;

    constructor(private http: HttpClient) {
        super();
    }


    /**
     * Retorna la respuesta del servicio para verificar el estado de edición de los datos.
     * @returns Respuesta con el estado de modificación de los datos
     */
    public getValidacionEdicion(): Observable<ValidaEdicionResponse> {

        this.endpoint = this.baseUrl + this.basePath + _.get(this.baseEndpoint, 'PASO_3.VALIDA_EDICION');

        return this.http.get<ValidaEdicionResponse>(this.endpoint);
    }
}
